export function calculateAge(birthday: Date, targetDate: Date): number {
  let age = targetDate.getFullYear() - birthday.getFullYear();
  const monthDiff = targetDate.getMonth() - birthday.getMonth();
  
  // Если месяц еще не наступил или наступил, но день еще не прошел
  if (monthDiff < 0 || (monthDiff === 0 && targetDate.getDate() < birthday.getDate())) {
      age--;
  }
  
  return age;
}
